// ******** NOTE **********
// this helper is for backward compatibility, need to remove it when contentful has no
// utilityBox in centre and all are updated to be a module
import { DISCOVER } from '../constants'

const getUtilityPanelModule = (centre, modules) => {
  let module = modules.find(x => x.sys.contentTypeId === 'utilityPanel')
  if (!module) {
    module = {
      entries: centre.utilityBoxRetailerCategories,
      centre,
      heading: `${DISCOVER} ${centre.title}`,
      isUtilityBox: true,
      sys: { id: 'dummy', contentTypeId: 'utilityPanel' },
      displayMode: 'UtilityPanel',
    }
    modules.splice(0, 0, module)
  }

  return module
}
export default getUtilityPanelModule
